const enums = {
  userRoles: [
    { id: 1, role: 'Manager' },
    { id: 2, role: 'SuperAdmin' },
    { id: 3, role: 'Operator' },
    { id: 4, role: 'Maintenance staff' },
    { id: 5, role: 'Executive' },
    { id: 6, role: 'Company Admin' },
    { id: 7, role: 'Technician' },
    { id: 8, role: 'Branch Admin' },
  ],
  userRoles1: [
    { id: 1, role: 'Manager' },
    { id: 2, role: 'SuperAdmin' },
  ],
  sites: [
    { id: 1, site: 'Richmond - CA ' },
    { id: 2, site: 'San Jose' },
  ],
  webApp: [
    { id: 1, app: 'Asset Care', name: 'AssetCare' },
    { id: 2, app: 'Tow Inspection', name: 'Tow Inspections' },
  ],
  assetStatus: [
    { id: 3, status: 'Active' },
    { id: 4, status: 'Inactive' },
    { id: 5, status: 'InMaintenanace' },
    { id: 6, status: 'Disposed' },
    { id: 7, status: 'InTransfer' },
  ],
  inspectionStatus: [
    { id: 8, status: 'Pending' },
    { id: 9, status: 'Cancelled' },
    { id: 10, status: 'Accepted' },
    { id: 11, status: 'InMaintenanace' },
    { id: 16, status: 'Rejected' },
  ],
  workOrderStatus: [
    { id: 12, status: 'New' },
    { id: 13, status: 'InProgress' },
    { id: 14, status: 'Waiting' },
    { id: 15, status: 'Completed' },
  ],
  workOrderStatus1: [
    { id: '', status: 'Select a Status' },
    { id: 12, status: 'New' },
    { id: 13, status: 'InProgress' },
    { id: 14, status: 'Waiting' },
    { id: 15, status: 'Completed' },
  ],
  createWorkOrderType: [
    { id: 1, status: 'Inspection' },
    { id: 2, status: 'WorkOrder' },
  ],
  approveInspectionFromType: [
    { id: 1, status: 'Dashboard' },
    { id: 2, status: 'Inspection' },
  ],
  priority: [
    { id: 1, priority: 'Very High' },
    { id: 2, priority: 'High' },
    { id: 3, priority: 'Medium' },
    { id: 4, priority: 'Low' },
  ],
  userStatus: [
    { id: 1, status: 'Active' },
    { id: 2, status: 'Inactive' },
  ],
  notificationType: [
    { id: 1, status: 'AutoApproveInspection ' },
    { id: 2, status: 'PendingNewInspection' },
    { id: 6, status: 'UpdateWorkOrderStatus ' },
  ],
  reportType: [
    { id: 1, type: 'Yard Report' },
    { id: 2, type: 'Equipment Type Report' },
    { id: 3, type: 'Asset Report' },
    { id: 4, type: 'Latest Hour Reading Report' },
    { id: 5, type: 'Asset Inspection Report' },
  ],
  reportStatus: [
    { id: 17, type: 'InProgress' },
    { id: 18, type: 'Completed' },
    { id: 19, type: 'Failed' },
  ],
  inspectionFormCategory: [
    { id: 1, category: 'Daily Inspection Items' },
    { id: 2, category: 'Critical Inspection Items' },
    { id: 3, category: '' },
    { id: 4, category: 'Tank Level' },
    { id: 5, category: 'Tank Containment' },
  ],
  gasolineAttributes: [
    { id: 1, value: 'E' },
    { id: 2, value: '1/4' },
    { id: 3, value: '1/3' },
    { id: 4, value: '1/2' },
    { id: 5, value: '2/3' },
    { id: 6, value: '3/4' },
    { id: 7, value: 'F' },
  ],
  tankLevelAttributes: [
    { id: 1, value: 'Clean' },
    { id: 2, value: 'Not Clean' },
  ],
  toastMsgType: [
    { id: 1, type: 'Success' },
    { id: 2, type: 'error' },
  ],
  Language: [
    { id: 1, language: 'English' },
    { id: 2, language: 'Spanish' },
  ],
  assetFilterStatus: [
    { id: 0, status: 'All' },
    { id: 1, status: 'Active' },
    { id: 2, status: 'Inactive' },
  ],

  triggerType: [
    { id: 24, status: 'Fixed One Time' },
    { id: 25, status: 'Recurring' },
  ],
  triggerBy: [
    { id: 26, status: 'Time' },
    { id: 27, status: 'Meter Hours' },
    { id: 28, status: 'Time / Meter Hours' },
    { id: 29, status: 'Month' },
    { id: 30, status: 'Year' },
  ],

  resMessages: {
    uploadAsset: 'Assets uploaded successfully',
    userInValid: 'Username or password is invalid',
    ApproveInspection: 'Inspection approved successfully.',
    UpdateWorkOrder: 'Work order updated successfully.',
    createeWorkOrder: 'Work order created successfully.',
    selectAsset: 'Please select atleast one asset',
    selectUser: 'Please select atleast one user',
    createUser: 'User created successfully.',
    updateUser: 'User updated successfully.',
    updateProfile: 'User profile updated successfully.',
    uploadInspectionForms: 'Inspection forms uploaded successfully',
    pendingInspectionApprove: 'Please first verify previous pending inspections',
    updateMeterHour: 'Meter hours successfully updated',
    emailNotificationSuccess: 'Settings updated successfully!',
    emailNotificationError: 'Unable to update the setting, please try again',
    awsLoginFailResponse: 'Something went wrong!',
    updateDefaultRole: 'Default role is updated',
    updateDefaultSite: 'Default site is updated',
    updateDefaultApp: 'Default app is updated',
    forgotpassmsg: 'Please check your email for instructions to reset your password',
    resetPasswordFail: 'Unable to change password, please verify email',
    resetPasswordSuccess: 'Password updated successfully!',
    notificationClickMsg: 'Your active role is not authorised to access this notification.',
    status_401: 'Access to this feature requires valid authentication credentials. Please log in again to resolve the issue. If the problem persists, kindly contact the administrator for further assistance.',
    status_403: 'Access to this feature is limited to users with specific roles. Please log in again to address the issue. If the problem persists, kindly reach out to administrator for further assistance.',
    status_440: 'You have logged into your account from another browser or device. For security reasons, you have been logged out of this session. Please log in again to continue.',
    msg_delete_attachment: 'Attachments deleted successfully',
    msg_upload_template: 'Attachment uploaded successfully',
    msg_template: 'Template uploaded successfully',
    msg_otp: 'OTP sent successfully',
  },
  errorMessages: {
    error_msg_delete_attachment: 'Something went wrong while deleting the attachment.',
    error_msg_upload_template: 'Something went wrong while uploading the attachment.',
    error_msg_template: 'Something went wrong while uploading the template.',
    error_msg_docx: 'Invalid DOCX format!',
    error_msg_file_format: 'Unsupported template! Please download the sample file, update it, and try uploading again.',
    error_msg_otp_expired: 'OTP Expired. Please request a new OTP.',
    error_msg_invalid_otp: 'Invalid OTP: Please check and try again.',
  },
  platform: 2, //web,
  domainName: 'ss',

  woTaskStatus: {
    Open: 68,
    InProgress: 13,
    ReadyForReview: 70,
    Complete: 15,
    Hold: 69,
    Recheck: 71,
    Reject: 16,
    Planned: 72,
    ReleasedOpen: 73,
    Submitted: 75,
  },

  workOrderTaskStatusList: [
    { id: 68, status: 'Open' },
    { id: 13, status: 'In Progress' },
    { id: 70, status: 'Ready for Review' },
    { id: 15, status: 'Completed' },
    { id: 69, status: 'Hold' },
    { id: 71, status: 'Recheck' },
    { id: 75, status: 'Submitted' },
  ],
  woType: {
    Acceptance: 66,
    Maintainance: 67,
    Troubleshoot: 77,
    OnBoarding: 76,
    InfraredScan: 78,
  },

  WO_STATUS: [
    { value: 73, label: 'Released Open', color: '#003DDA' },
    { value: 68, label: 'Open', color: '#003DDA' },
    { value: 13, label: 'In Progress', color: '#3291DD' },
    { value: 70, label: 'Ready for Review', color: '#FA0B0B' },
    { value: 15, label: 'Completed', color: '#5D8C21' },
    { value: 69, label: 'Hold', color: '#FF9D33' },
    { value: 71, label: 'Recheck', color: '#FA0B0B' },
    { value: 16, label: 'Rejected', color: '#FA0B0B' },
    { value: 72, label: 'Planned', color: '#ED3FDC' },
    { value: 75, label: 'Submitted', color: '#7d07ff' },
  ],
  WO_TYPE_LIST: [
    { label: 'Acceptance Test WO', value: 66 },
    { label: 'Maintenance WO', value: 67 },
    { label: 'On Boarding', value: 76 },
    { label: 'Infrared Scan', value: 78 },
  ],
  PDF_REPORT_STATUS: {
    InProgress: 17,
    Completed: 18,
    Failed: 19,
  },
  CONDITION_INDEX_COLORS: {
    red: '#ff5f6e',
    green: '#37d482',
    orange: '#ff950a',
    yellow: '#ffa71a',
    good: '#37d482',
    average: '#ffd41a',
    poor: '#ff5f6e',
    dusty: '#840404',
    lightBlue: '#0E7ED1',
    turquoise: '#4CDBC5',
    lightBrown: '#F3C49F',
    ultramarine: '#96D6ED',
  },

  ISSUE_COLORS: {
    open: '#003DDA',
    inProgress: '#3291DD',
    scheduled: '#fcba03',
  },

  INSPECTION_VERDICT_CHIPS: [
    { value: 1, label: 'Pass', color: '#0dbf16' },
    { value: 2, label: 'Repair Needed ', color: '#fcba03' },
    { value: 3, label: 'Replacement Needed ', color: '#fc2803' },
    { value: 4, label: 'Defective', color: '#643e38' },
  ],
  ASSET_STATUS_CHIPS: [
    { value: 3, label: 'ACTIVE', color: '#0dbf16' },
    { value: 4, label: 'INACTIVE', color: '#fcba03' },
  ],
  USER_STATUS_CHIPS: [
    { value: 1, label: 'Active', color: '#0dbf16' },
    { value: 2, label: 'Inactive', color: '#fc2803' },
  ],
  FORM_STATUS: {
    draft: 74,
    published: 1,
  },
  FORM_STATUS_CHIPS: [
    { value: 1, label: 'Published', color: '#0dbf16' },
    { value: 74, label: 'Draft', color: '#fcba03' },
  ],
  PHOTOS: [
    { value: 1, label: 'Profile' },
    { value: 2, label: 'Nameplate' },
    { value: 3, label: 'Thermal Anomly' },
    { value: 4, label: 'NEC Violation' },
    { value: 5, label: 'Osha Violation' },
    { value: 6, label: 'General (Additional)' },
    { value: 7, label: 'Nameplate (Additional)' },
    { value: 8, label: 'Before (Additional)' },
    { value: 9, label: 'After (Additional)' },
    { value: 10, label: 'Environment (Additional)' },
    { value: 11, label: 'IR' },
    { value: 12, label: 'Visual' },
    { value: 13, label: 'Exterior' },
    { value: 14, label: 'Schedule' },
    { value: 15, label: 'Additional' },
    { value: 16, label: 'Repair' },
    { value: 17, label: 'Replacement' },
    { value: 18, label: 'Other' },
    { value: 19, label: 'Before (Issue)' },
    { value: 20, label: 'After (Issue)' },
    { value: 23, label: 'Arc Flash Label Photos' },
  ],
  CONDITION: {
    POOR: 1,
    AVERAGE: 2,
    GOOD: 3,
    DUSTY: 4,
  },
  MAINTENANCE_CONDITION: {
    SERVICEABLE: 1,
    LIMITED_SERVICE: 2,
    NON_SERVICEABLE: 3,
  },
  PHYSICAL_CONDITION: {
    OPERATING_NORMALLY: 1,
    REPAIR_NEDDED: 2,
    REPLACEMENT_NEEDED: 3,
    REPAIR_SCHEDULED: 4,
    REPLACEMENT_SCHEDULED: 5,
    DECOMMISIONED: 6,
    SPARE: 7,
  },
  CRITICALITY: {
    LOW: 1,
    MEDIUM: 2,
    HIGH: 3,
  },
  SEVERITY_CRITERIA: {
    SIMILAR: 1,
    AMBIENT: 2,
    INDIRECT: 3,
  },
  PANEL: {
    CURRENT: 1,
    NEEDS_UPDATING: 2,
    MISSING: 3,
  },
  THERMAL_CLASSIFICATION: {
    OK: 1,
    NOMINAL: 2,
    INTERMIDIATE: 3,
    SERIOUS: 4,
    CRITICAL: 5,
    ALERT: 6,
  },
  ULTRASONIC_ANOMALY: {
    CRACK: 1,
    VOID: 2,
    DELAMINATION: 3,
    INCLUSIONS: 4,
    CORROSION: 5,
    POROSITY: 6,
  },
  MWO_INSPECTION_TYPES: {
    INSTALL: 1,
    ONBOARDING: 1,
    INSPECTION: 2,
    REPAIR: 3,
    REPLACE: 4,
    TROUBLE_CALL_CHECK: 5,
    ISSUE: 6,
    PM: 7,
  },
  ISSUE: {
    STATUS: { OPEN: 68, IN_PROGRESS: 13, SCHEDULED: 80, RESOLVED: 15 },
    PRIORITY: { VERY_HIGH: 1, HIGH: 2, MEDIUM: 3, LOW: 4 },
    TYPE: { COMPLIANCE: 1, THERMAL_ANAMOLY: 2, REPAIR: 3, REPLACE: 4, OTHER: 6, OSHA_VIOLATION: 7, NEC_VIOLATION: 8, ULTRASONIC_ANOMALY: 9, NFPA_70B_VIOLATION: 10 },
    CAUSED: { OSHA_VIOLATION: 1, NEC_VIOLATION: 2, NFPA_70B_VIOLATION: 14 },
  },
  PM: {
    STATUS: { OPEN: 1, COMPLETED: 15, INPROGRESS: 13, SCHEDULE: 80, OVERDUE: 31, QUOTE_OPEN: 86, SEND_TO_CUSTOMER: 87, COUSTOMER_DEFERRED: 88, COUSTOMER_REJECTED: 89, SCHEDULE_PENDING: 90 },
  },
  WO_COMPLETION_STATUS: {
    IN_PROGRESS: 1,
    COMPLETED: 2,
    FAILED: 3,
  },
  BULK_UPLOAD_STATUS: {
    COMPLETED: 1,
    IN_PROGRESS: 2,
    FAILED: 3,
  },
  COMPONENT_TYPE: {
    TOP_LEVEL: 1,
    SUB_COMPONENT: 2,
  },
  FED_BY_TYPE: {
    NORMAL: 1,
    EMERGENCY: 2,
  },
  EQUIPMENT: {
    CALIBRATED: 1,
    NOTCALIBRATED: 2,
    NA: 3,
  },
  NOTIFICATION: {
    NEW: 1,
    READ: 2,
  },
  NOTIFICATION_TYPE: {
    WORKORDER_ASSIGNED_TO_TECHNICIAN: 1,
    SITE_ASSIGNED_TO_USER: 2,
    ALL_WOLINES_COMPLETED_OR_READYFORREVIEW_OF_WO: 3,
    WORKORDER_IS_COMPLETED_WITH_ISSUE_CREATED: 4,
    ASSIGNED_WORKORDER_ISDUE: 5,
    WORKORDER_ISOVERDUE: 6,
  },
  DASHBOARD: {
    INSIGHTS: 1,
    PM: 2,
    BUSINESS_OVERVIEW: 3,
    ASSET_OVERVIEW: 4,
    NFPA_70B_COMPLIANCE: 5,
    NFPA_70E_COMPLIANCE: 6,
    FEATURE_WISE: {
      ESTIMATOR: 1,
    },
  },
  WO_DUE_FLAG: {
    DUE: 1,
    OVERDUE: 2,
    DUEINDAYS: 3,
  },
  QUOTES: {
    STATUS: { OPEN: 68, SUBMITTED: 75, ACCEPTED: 82, REJECTED: 83, DEFERRED: 81, RELEASED: 73 },
    quotesType: { Maintainance: 1, InfraredThermography: 2, Audit: 3 },
    TIME_MATERIAL_CATEGORY: { LABOR: 1, MATERIALS: 2, MISCELLANEOUS: 3, SUBCONTRACTS: 4, INDIRECT_LABOR_COST: 5, INDIRECT_JOB_COST: 6, THIRD_PARTY_RENTAL: 7 },
    TIME_MATERIAL_UNIT: { UNIT: 1, FEET: 2, BLANK: 3 },
    BURDEN_TYPE: { DOLLAR: 1, PERCENTAGE: 2 },
  },

  REMINDER_DURATION: {
    DAY: 1,
    HOURS: 2,
  },
  SUB_COMPONENT_TYPE: {
    LINE_SIDE: 1,
    LOAD_SIDE: 2,
  },

  NODE_TYPE: {
    MLO: 1,
    MCB: 2,
  },

  ASSET_TYPE: {
    ARRESTERS: 'ARRESTERS',
    BATTERIES: 'BATTERIES',
    BUS: 'BUS',
    CABLES: 'CABLES',
    CAPACITORS: 'CAPACITORS',
    CIRCUIT_BREAKERS: 'CIRCUIT BREAKERS',
    ELECTRICAL_PANELS: 'ELECTRICAL PANELS',
    ELECTRICAL_PANELS_MCEQ: 'ELECTRICAL PANELS(PANL, MCEQ-LV,MCEQ-MV)',
    ELECTRICAL_PANELS_ALL: 'ELECTRICAL PANELS (ALL OTHERS)',
    FUSES: 'FUSES',
    GENERATORS: 'GENERATORS',
    GROUND: 'Ground',
    GROUNDING_BONDING: 'GROUNDING / BONDING',
    GROUND_FAULT_SYSTEMS: 'GROUND FAULT SYSTEMS',
    INSTRUMENT_TRANSFORMERS: 'INSTRUMENT TRANSFORMERS',
    METERS_READING: 'Meter Reading',
    METERS: 'METERS',
    MISCELLANEOUS: 'MISCELLANEOUS',
    MOTORS: 'MOTORS',
    RELAYS: 'RELAYS',
    SWITCHES: 'SWITCHES',
    SWITCHES_ALL: 'SWITCHES (ALL OTHERS)',
    SWITCHES_DISC: 'SWITCHES (DISC-FLV, DISC-F-MV)*',
    TRANSFER_SWITCHES: 'TRANSFER SWITCHES',
    TRANSFORMERS: 'TRANSFORMERS',
    UPS_SYSTEMS: 'UPS SYSTEMS',
    CONTACTORS: 'CONTACTORS',
    DC_INSULATION: 'DC INSULATION',
    RECLOSER: 'RECLOSER',
  },
  ASSET_TYPE_ICON_COLOR: '#778899',
  AWS_CODE: {
    NotAuthorizedException: 'NotAuthorizedException',
  },
  REPORT_INSPECTION_TYPE: {
    ACCEPTANCE_TEST: 1,
    MAINTENANCE: 2,
  },
  NETAINSPECTION_REPORT_STATUS_TYPE: {
    COMPLETED: 1,
    IN_PROGRESS: 2,
    PARTIAL_COMPLETED: 3,
    FAILED: 4,
  },
  UPLOAD_IRPHOTO_CHUNK_SIZE: 20,
  DELETE_BULK_ASSET_SIZE: 50,
  PHOTO_TYPE: {
    IR_ONLY: 1,
    VISUAL_ONLY: 2,
    IR_VISUAL_SEPARATE: 3,
  },
  CAMERA_TYPE: {
    FLIR: 1,
    FLUKE: 2,
  },
  AWS_Bucket_Type: {
    Asset_images: 1,
    wo_attachments: 2,
    inspection_images: 3,
    IR_Visual_Images: 4,
  },
  DEFAULT_PAGE_SIZE: 100,
  PAGE_ARRAY_LIST: [20, 40, 60, 80, 100, 250, 500],
  HEALTH: {
    ALL: null,
    NA: 'NA',
    ACCEPTABLE: 'Acceptable',
    ALERT: 'Alert',
    DANGER: 'Danger',
  },
  DROPDOWN_OPTIONS: {
    CONDUCTOR_SIZE: 1,
    OSHA_VIOLATION: 2,
    NEC_VIOLATION: 3,
    NFPA70B_VIOLATION: 4,
    THERMAL_ANAMOLY_SUBCOMPONENT: 5,
    ISSUE_TYPE: 6,
    ULTRASONIC_ANAMOLY: 7,
    THERMAL_CLASSIFICATION: 8,
    THERMAL_ANOMALY_LOCATION_OPTIONS: 9,
    THERMAL_ANOMALY_PROBABLE_CAUSE_OPTIONS: 10,
    THERMAL_ANOMALY_RECOMMENDATION_OPTIONS: 11,
    PHYSICAL_CONDITION_OPTIONS: 12,
    TIME_CATEGORY: 13,
    VIEW_OPTIONS: 14,
    VENDOR_CATEGORY_OPTIONS: 15,
    CONTACT_CATEGORY_OPTIONS: 16,
    RESOLUTION_TYPES: 17,
  },
}
export default enums
